// import React, { useState } from 'react';
// import { Link, useLocation, useNavigate } from 'react-router-dom';
// import { motion, AnimatePresence } from 'framer-motion';
// import { 
//   FaThLarge, FaUsers, FaBox, FaImage, 
//   FaVideo, FaStar, FaTags, FaSignOutAlt, FaChevronDown 
// } from 'react-icons/fa';
// import { useAdminAuth } from '../context/AdminAuthContext'; // Sahi context import kiya

// const AdminSidebar: React.FC = () => {
//   const location = useLocation();
//   const [openMenu, setOpenMenu] = useState<string | null>(null);
//   const navigate = useNavigate();
  
//   // Context se role aur logout function nikala
//   const { logout, role } = useAdminAuth(); 

//   const handleLogout = () => {
//     logout(); // Yeh context wala logout hai jo clear aur navigate dono karega
//   };

//   const toggleMenu = (name: string) => {
//     setOpenMenu(openMenu === name ? null : name);
//   };

//   const menuGroups = [
//     {
//       title: 'Users',
//       icon: <FaUsers />,
//       subItems: [
//         { name: 'User List', path: '/frog-side/users' },
//         { name: 'Seller Activity', path: '/frog-side/sellers' },
//         { name: 'Order', path: '/frog-side/orders' },
//         { name: 'Best Dealer', path: '/frog-side/best-dealers' },
//       ]
//     },
//     {
//       title: 'Category',
//       icon: <FaBox />,
//       subItems: [
//         { name: 'Add Category', path: '/frog-side/add-category' },
//         { name: 'Category List', path: '/frog-side/category-list' },
//       ]
//     },
//     {
//       title: 'Management',
//       icon: <FaImage />,
//       subItems: [
//         { name: 'Banners', path: '/frog-side/banners' },
//         { name: 'Ads Management', path: '/frog-side/ads/add' },
//         { name: 'Issues', path: '/frog-side/issues' },
//       ]
//     },
//     {
//       title: 'Team',
//       icon: <FaUsers />,
//       subItems: [
//         // Role check logic: Sirf SUPER_ADMIN ya ADMIN ko Approval dikhega
//         ...(role === 'SUPER_ADMIN' || role === 'ADMIN' 
//           ? [{ name: 'Approval Requests', path: '/frog-side/approval' }] 
//           : []),
//         { name: 'My Subordinates', path: '/frog-side/subordinates' },
//         { name: 'Give Access', path: '/frog-side/give-access' },
//       ]
//     }
//   ];

//   return (
//     <aside className="fixed left-0 top-0 h-screen w-64 bg-white border-r border-gray-50 flex flex-col z-50 shadow-sm">
//       <div className="p-8 shrink-0">
//         <div className="flex items-center gap-3 group cursor-pointer" onClick={() => navigate('/frog-side/dashboard')}>
//           <div className="w-10 h-10 bg-[#006d5b] rounded-xl flex items-center justify-center shadow-lg shadow-[#006d5b]/20 group-hover:scale-110 transition-transform">
//             <span className="text-white font-black text-xl italic">F</span>
//           </div>
//           <span className="text-xl font-black tracking-tighter text-gray-800">FROG<span className="text-[#006d5b]">SIDE</span></span>
//         </div>
//       </div>

//       <nav className="flex-1 overflow-y-auto px-4 custom-scrollbar">
//         <ul className="space-y-2">
//           <li>
//             <Link
//               to="/frog-side/dashboard"
//               className={`flex items-center gap-4 px-6 py-4 rounded-2xl text-xs font-bold tracking-widest transition-all
//               ${location.pathname === '/frog-side/dashboard' 
//                 ? 'bg-[#006d5b] text-white shadow-lg shadow-[#006d5b]/20' 
//                 : 'text-gray-400 hover:bg-gray-50 hover:text-gray-600'}`}
//             >
//               <FaThLarge size={18} />
//               DASHBOARD
//             </Link>
//           </li>

//           {menuGroups.map((group) => {
//             const isGroupActive = group.subItems.some(sub => location.pathname === sub.path);
//             const isOpen = openMenu === group.title;

//             return (
//               <li key={group.title} className="space-y-1">
//                 <button
//                   onClick={() => toggleMenu(group.title)}
//                   className={`w-full flex items-center justify-between px-6 py-4 rounded-2xl text-xs font-bold tracking-widest transition-all
//                   ${isGroupActive || isOpen ? 'text-gray-800' : 'text-gray-400 hover:bg-gray-50'}`}
//                 >
//                   <div className="flex items-center gap-4">
//                     <span className={isGroupActive || isOpen ? 'text-[#006d5b]' : ''}>{group.icon}</span>
//                     {group.title.toUpperCase()}
//                   </div>
//                   <FaChevronDown 
//                     size={10} 
//                     className={`transition-transform duration-300 ${isOpen ? 'rotate-180 text-[#006d5b]' : ''}`} 
//                   />
//                 </button>

//                 <AnimatePresence>
//                   {isOpen && (
//                     <motion.ul
//                       initial={{ opacity: 0, height: 0 }}
//                       animate={{ opacity: 1, height: 'auto' }}
//                       exit={{ opacity: 0, height: 0 }}
//                       className="overflow-hidden space-y-1"
//                     >
//                       {group.subItems.map((sub) => {
//                         const isActive = location.pathname === sub.path;
//                         return (
//                           <li key={sub.path} className="px-2">
//                             <Link
//                               to={sub.path}
//                               className={`flex items-center gap-4 px-6 py-2.5 rounded-xl text-xs font-bold transition-all
//                               ${isActive 
//                                 ? 'text-[#006d5b] bg-[#006d5b]/10 border-l-4 border-[#006d5b]' 
//                                 : 'text-gray-400 hover:text-gray-600 hover:translate-x-1'}`}
//                             >
//                               <span>{sub.name}</span>
//                             </Link>
//                           </li>
//                         );
//                       })}
//                     </motion.ul>
//                   )}
//                 </AnimatePresence>
//               </li>
//             );
//           })}
//         </ul>
//       </nav>

//       <div className="p-8 border-t border-gray-50 shrink-0">
//        <button 
//           onClick={handleLogout}
//           className="flex items-center gap-3 text-red-500 font-bold text-xs tracking-widest hover:bg-red-50 rounded-xl px-4 py-3 w-full transition-all border border-transparent hover:border-red-100"
//         >
//           <FaSignOutAlt />
//           LOGOUT
//         </button>
//       </div>
//     </aside>
//   );
// };

// export default AdminSidebar;
import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { FaThLarge, FaChevronDown, FaSignOutAlt, FaCogs } from 'react-icons/fa';
import * as Icons from 'react-icons/fa';
import { useAdminAuth } from '../context/AdminAuthContext';

const AdminSidebar: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { logout, role, permissions } = useAdminAuth(); 
  const [menuGroups, setMenuGroups] = useState<any[]>([]);
  const [openMenu, setOpenMenu] = useState<string | null>(null);

  // 1. Spring Boot (Port 2027) se aayi permissions parse karna
  const savedPermissions = React.useMemo(() => {
    try {
      return typeof permissions === 'string' ? JSON.parse(permissions || "{}") : (permissions || {});
    } catch (e) {
      return {};
    }
  }, [permissions]);

  useEffect(() => {
    // 2. Node.js (Port 2026) se Sidebar Structure fetch karna
    fetch("http://localhost:2026/api/sidebar/all")
      .then(res => res.json())
      .then(data => setMenuGroups(Array.isArray(data) ? data : []))
      .catch(err => console.error("Node.js sidebar fetch failed", err));
  }, []);

  const renderIcon = (iconName: string) => {
    const IconComponent = (Icons as any)[iconName];
    return IconComponent ? <IconComponent size={18} /> : <Icons.FaBox size={18} />;
  };

  return (
    <aside className="fixed left-0 top-0 h-screen w-64 bg-white border-r border-gray-50 flex flex-col z-50 shadow-sm">
      <div className="p-8 shrink-0 cursor-pointer" onClick={() => navigate('/frog-side/dashboard')}>
         <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-[#006d5b] rounded-xl flex items-center justify-center text-white font-black shadow-lg">F</div>
            <span className="text-xl font-black text-gray-800 tracking-tighter">TRADY<span className="text-[#006d5b]">FROG</span></span>
         </div>
      </div>

      <nav className="flex-1 overflow-y-auto px-4 custom-scrollbar">
        <ul className="space-y-2">
          {/* Dashboard - Static (Spring Boot logic usually allows this by default) */}
          <li>
            <Link to="/frog-side/dashboard" className={`flex items-center gap-4 px-6 py-4 rounded-2xl text-xs font-bold tracking-widest transition-all ${location.pathname === '/frog-side/dashboard' ? 'bg-[#006d5b] text-white shadow-lg shadow-[#006d5b]/20' : 'text-gray-400 hover:bg-gray-50'}`}>
              <FaThLarge size={18} /> DASHBOARD
            </Link>
          </li>

          {/* System Settings - Sirf Admin/SuperAdmin (Port 2027 Role Check) */}
          {(role === 'SUPER_ADMIN' || role === 'ADMIN') && (
            <li>
               <Link to="/frog-side/add-sidebar-menu" className={`flex items-center gap-4 px-6 py-4 rounded-2xl text-xs font-bold transition-all ${location.pathname === '/frog-side/add-sidebar-menu' ? 'bg-orange-500 text-white shadow-lg' : 'text-orange-500 hover:bg-orange-50'}`}>
                  <FaCogs size={18} /> SYSTEM SETTINGS
               </Link>
            </li>
          )}

          {/* Logic: Node.js groups ko filter karna Spring Boot ki permissions se */}
          {menuGroups.map((group) => {
            // Filter 1: SuperAdmin ko sab dikhao, Manager ke liye check karo Title enabled hai ya nahi
            const isGroupVisible = role === 'SUPER_ADMIN' || role === 'ADMIN' || !!savedPermissions[group.title];
            if (!isGroupVisible) return null;

            // Filter 2: Sirf wahi sub-menus (pages) rakho jo Spring Boot JSON mein 'true' hain
            const allowedPages = group.subItems.filter((sub: any) => {
              if (role === 'SUPER_ADMIN' || role === 'ADMIN') return true;
              return !!savedPermissions[sub.path]; // Deep check using path from Node.js
            });

            // Agar group ke andar ek bhi page allowed nahi hai, toh group hide kar do
            if (allowedPages.length === 0 && role !== 'ADMIN' && role !== 'SUPER_ADMIN') return null;

            const isOpen = openMenu === group.title;

            return (
              <li key={group.id || group.title} className="space-y-1">
                <button onClick={() => setOpenMenu(isOpen ? null : group.title)} className={`w-full flex items-center justify-between px-6 py-4 rounded-2xl text-xs font-bold tracking-widest transition-all ${isOpen ? 'text-gray-800' : 'text-gray-400 hover:bg-gray-50'}`}>
                  <div className="flex items-center gap-4">
                    <span className={isOpen ? 'text-[#006d5b]' : ''}>{renderIcon(group.icon)}</span>
                    {group.title.toUpperCase()}
                  </div>
                  <FaChevronDown size={10} className={`transition-transform duration-300 ${isOpen ? 'rotate-180 text-[#006d5b]' : ''}`} />
                </button>

                <AnimatePresence>
                  {isOpen && (
                    <motion.ul initial={{ opacity: 0, height: 0 }} animate={{ opacity: 1, height: 'auto' }} exit={{ opacity: 0, height: 0 }} className="overflow-hidden space-y-1 bg-gray-50/50 rounded-xl">
                      {allowedPages.map((sub: any, index: number) => (
                        <li key={`${group.title}-${index}`} className="px-2">
                          <Link to={sub.path} className={`block px-6 py-3 rounded-xl text-[10px] font-bold uppercase transition-all ${location.pathname === sub.path ? 'text-[#006d5b] bg-white shadow-sm border-l-4 border-[#006d5b]' : 'text-gray-400 hover:text-[#006d5b]'}`}>
                            {sub.name}
                          </Link>
                        </li>
                      ))}
                    </motion.ul>
                  )}
                </AnimatePresence>
              </li>
            );
          })}
        </ul>
      </nav>

      <div className="p-8 border-t border-gray-50 shrink-0">
        <button onClick={logout} className="flex items-center gap-3 text-red-500 font-bold text-xs tracking-widest hover:bg-red-50 rounded-xl px-4 py-3 w-full transition-all border border-transparent hover:border-red-100">
          <FaSignOutAlt /> LOGOUT SYSTEM
        </button>
      </div>
    </aside>
  );
};

export default AdminSidebar;